import { Injectable } from '@angular/core';
import { DxAccordionComponent } from 'devextreme-angular';

@Injectable({
  providedIn: 'root'
})
//Used in conjunction with dx-accordion
export class FormSectionService {

  constructor() { }

  setSummary(sectionTitle:string,summary:string,sections:any[]){
    sections.forEach(section=>{section.summary = section.title == sectionTitle ? summary: section.summary})
  }

  setErrors(sectionTitle:string,error:string,sections:any[]){
    sections.forEach(section=>{section.error = section.title == sectionTitle ? error: section.error});
  }

  closeAll(sections:any[],accordion:DxAccordionComponent){
    for (let i = 0; i < sections.length; i++) {
      accordion.instance.collapseItem(i);
    }
  }

  openSection(selector:string,sections:any[],accordion:DxAccordionComponent):boolean{
    for (let i = 0; i < sections.length; i++) {
      if(sections[i].selector==selector){
        accordion.instance.expandItem(i);
        return true;
      }
    }
    return false;
  }

}
